/**
 * Force cart section re-render after add-to-cart to show Shopify Function discounts.
 * Uses click listener on add-to-cart buttons + MutationObserver on cart drawer.
 */
(function () {
  var DELAY = 2000;

  // Listen for clicks on any add-to-cart button
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.cart-btn, .add-to-cart-button, [name="add"], [data-type="add-to-cart-form"] button');
    if (!btn) return;
    setTimeout(refreshCart, DELAY);
  });

  // Also observe the cart drawer for when it opens
  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var m = mutations[i];
      if (m.type === 'attributes' && m.attributeName === 'open') {
        setTimeout(refreshCart, DELAY);
        break;
      }
    }
  });

  // Observe cart drawer dialog
  function observeDrawer() {
    var dialogs = document.querySelectorAll('cart-drawer-component dialog, .cart-drawer dialog');
    dialogs.forEach(function (d) {
      observer.observe(d, { attributes: true, attributeFilter: ['open'] });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeDrawer);
  } else {
    observeDrawer();
  }

  function refreshCart() {
    var cartSections = document.querySelectorAll('cart-items-component');
    cartSections.forEach(function (el) {
      var sectionId = el.dataset.sectionId;
      if (!sectionId) return;

      var xhr = new XMLHttpRequest();
      xhr.open('GET', '/?sections=' + encodeURIComponent(sectionId), true);
      xhr.onload = function () {
        try {
          var data = JSON.parse(xhr.responseText);
          var html = data[sectionId];
          if (html) {
            var parser = new DOMParser();
            var doc = parser.parseFromString(html, 'text/html');
            var newEl = doc.querySelector('cart-items-component');
            if (newEl && el) {
              el.innerHTML = newEl.innerHTML;
            }
          }
        } catch (e) {}
      };
      xhr.send();
    });
  }
})();
